import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { FaturaProfissionalList } from '../core/_models'
import { faturaProfissionalAtendimentosColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaProfissionalAtendimentosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => faturaProfissionalAtendimentosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum atendimento encontrado para “${filters.protocolo.trim()}”`}
      description='Revise o protocolo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento nesta fatura'
      description='Os atendimentos faturados aparecem aqui.'
    />
  )

  return (
    <CustomTable<FaturaProfissionalList>
      id='kt_table_fatura_profissional_atendimentos'
      ariaLabel={t('title.atendimentos_fatura')}
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
